/**
 * @generated SignedSource<<455fa1610be216ee3aefa5a815dfa278>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecruitKPIs_study$data = {
  readonly allowAutoApproval: boolean;
  readonly tenant: {
    readonly requireStudyPayment: boolean;
  };
  readonly " $fragmentType": "RecruitKPIs_study";
};
export type RecruitKPIs_study$key = {
  readonly " $data"?: RecruitKPIs_study$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecruitKPIs_study">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecruitKPIs_study",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowAutoApproval",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TenantNode",
      "kind": "LinkedField",
      "name": "tenant",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requireStudyPayment",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StudyNode",
  "abstractKey": null
};

(node as any).hash = "dca907eb0f4ab46edcb433b7e844333f";

export default node;
